if ($("#workmodelCommon").length){
        $('#workmanagerAllmodels').addClass('current-page');
}
